import {
  IoBagHandle,
  IoBusiness,
  IoCalendar,
  IoCarSharp,
  IoGift,
  IoLink,
  IoMenu,
  IoNewspaper,
  IoNotifications,
  IoPeople,
  IoSettings,
  IoSparkles,
  IoStatsChart,
  IoStorefront,
  IoTicket,
  IoTime,
  IoWallet,
} from 'react-icons/io5';
import { DollarCircleFilled } from '@ant-design/icons';

export const ICON_MAP: Record<string, JSX.Element> = {
  dashboard: <IoStatsChart className='w-6 h-6' />, // 푼타컴퍼니 직원 대시보드
  'partner-dashboard': <IoStatsChart className='w-6 h-6' />, // 파트너 대시보드
  coupon: <IoTicket className='w-6 h-6' />, // 쿠폰 관리
  mileage: <DollarCircleFilled style={{ fontSize: '24px' }} />, // 마일리지 관리
  product: <IoBagHandle className='w-6 h-6' />, // 상품 관리
  user: <IoPeople className='w-6 h-6' />, // 회원 관리
  business: <IoBusiness className='w-6 h-6' />, // 파트너사 관리
  'cloud-scheduler': <IoCalendar className='w-6 h-6' />, // 스케줄 관리
  settlement: <IoWallet className='w-6 h-6' />, // 정산 관리
  brand: <IoStorefront className='w-6 h-6' />, // 브랜드 관리
  delivery: <IoCarSharp className='w-6 h-6' />, // 배송 관리
  partner: <IoBusiness className='w-6 h-6' />, // 파트너 관리
  'app-push': <IoNotifications className='w-6 h-6' />, // 앱 푸시 관리
  magazine: <IoNewspaper className='w-6 h-6' />, // 매거진 관리
  'spot-time': <IoTime className='w-6 h-6' />, // 픽업 스팟 시간 관리
  'pick-round': <IoSettings className='w-6 h-6' />, // 픽업 회차 관리
  idus: <IoSparkles className='w-6 h-6' />, // 아이더스 관리
  referral: <IoGift className='w-6 h-6' />, // 추천인 관리
  deeplink: <IoLink className='w-6 h-6' />, // 딥링크 관리
  'system-settings': <IoSettings className='w-6 h-6' />, // 시스템 설정 관리
  MenuOutlined: <IoMenu className='w-6 h-6' />, // 메뉴 관리
};
